import { v4 as uuidv4 } from 'uuid';

export function SellerPrice(props = {}, childrenComponents = []) {
	return {
		componentName: 'SellerPrice',
		componentId: uuidv4(),
		title: '',
		props: Object.assign({}, props),
		childrenComponents,
	};
}
